import { formatDateOnlyBR } from './dateFormat';

export const brl = (v) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const TIPO_LABEL = { ativacao: 'Carga de ativação', recarga: 'Recarga' };
export const MODO_LABEL = { automatica: 'Automática', manual: 'Manual' };

const COLUNAS = ['Cliente', 'CPF', 'Número', 'Tipo', 'Modo', 'Data', 'Hora', 'Plano na Tip', 'Oferta', 'Custo', 'Motivo'];
const linha = (i) => [i.cliente_nome, i.cpf, i.numero, TIPO_LABEL[i.tipo], MODO_LABEL[i.modo], formatDateOnlyBR(i.data), i.hora || '-',
  i.plano_tip || '-', i.oferta_nome, Number(i.custo || 0).toFixed(2).replace('.', ','), i.motivo];
const somar = (itens) => itens.reduce((s, i) => s + (i.custo || 0), 0);
const RESUMO = (r) => [['Total', r.total], ['Cargas de ativação', r.ativacoes], ['Recargas automáticas', r.recargas_automaticas], ['Recargas manuais', r.recargas_manuais]];
const alertaTxt = (a) => `${a.cliente_nome || 'Sem cliente'} · ${a.numero} · ${a.mes.split('-').reverse().join('/')}: ${a.quantidade}x = ${brl(a.total)} (${a.eventos.map(e => `${formatDateOnlyBR(e.data)} ${(e.hora || '').slice(0, 5)} ${TIPO_LABEL[e.tipo]}`).join(' | ')})`;

function baixar(blob, nome) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = nome; a.click();
  URL.revokeObjectURL(url);
}

export function exportarRecargasCsv(itens, inicio, fim) {
  const rows = [COLUNAS, ...itens.map(linha), [], ['Total', '', '', '', '', '', '', '', `${itens.length} lançamento(s)`, somar(itens).toFixed(2).replace('.', ',')]];
  const csv = rows.map(r => r.map(c => `"${String(c ?? '').replace(/"/g, '""')}"`).join(';')).join('\n');
  baixar(new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' }), `recargas_tip_${inicio}_a_${fim}.csv`);
}

export async function exportarRecargasPdf(dados, itens) {
  const { jsPDF } = await import('jspdf');
  const { default: autoTable } = await import('jspdf-autotable');
  const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  pdf.setFontSize(14);
  pdf.text('Cargas e recargas cobradas pela Tip', 14, 14);
  pdf.setFontSize(9);
  pdf.text(`Período: ${formatDateOnlyBR(dados.inicio)} a ${formatDateOnlyBR(dados.fim)}  ·  Gerado em ${new Date().toLocaleString('pt-BR')}`, 14, 20);
  pdf.text(RESUMO(dados.resumo).map(([t, v]) => `${t}: ${v.quantidade} · ${brl(v.total)}`).join('     '), 14, 26);
  let y = 30;
  if (dados.alertas.length) {
    autoTable(pdf, {
      startY: y, head: [[`Atenção: ${dados.alertas.length} linha(s) com mais de 1 carga/recarga no mesmo mês`]],
      body: dados.alertas.map(a => [alertaTxt(a)]), styles: { fontSize: 7 }, headStyles: { fillColor: [180, 83, 9] },
    });
    y = pdf.lastAutoTable.finalY + 4;
  }
  autoTable(pdf, {
    startY: y, head: [COLUNAS.slice(0, 10)], body: itens.map(i => linha(i).slice(0, 10)),
    foot: [['Total', '', '', '', '', '', '', '', `${itens.length} lançamento(s)`, brl(somar(itens))]],
    styles: { fontSize: 7, cellPadding: 1.5 }, headStyles: { fillColor: [39, 39, 42] }, footStyles: { fillColor: [228, 228, 231], textColor: 20 },
  });
  pdf.save(`recargas_tip_${dados.inicio}_a_${dados.fim}.pdf`);
}

const esc = (s) => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

export function imprimirRecargas(dados, itens) {
  const cards = RESUMO(dados.resumo).map(([t, v]) => `<div class="card"><b>${t}</b><br>${v.quantidade} · ${brl(v.total)}</div>`).join('');
  const alertas = dados.alertas.length ? `<h3>Atenção: ${dados.alertas.length} linha(s) com mais de 1 carga/recarga no mesmo mês</h3><ul>${dados.alertas.map(a => `<li>${esc(alertaTxt(a))}</li>`).join('')}</ul>` : '';
  const corpo = itens.map(i => `<tr>${linha(i).slice(0, 10).map(c => `<td>${esc(c)}</td>`).join('')}</tr>`).join('');
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.write(`<html><head><title>Recargas Tip ${dados.inicio} a ${dados.fim}</title><style>
    body{font-family:Arial,sans-serif;font-size:11px;color:#111;margin:20px} h2{margin:0 0 4px} .cards{display:flex;gap:8px;margin:12px 0}
    .card{border:1px solid #999;padding:6px 10px;border-radius:4px} table{border-collapse:collapse;width:100%} th,td{border:1px solid #bbb;padding:3px 5px;text-align:left}
    th{background:#eee} tfoot td{font-weight:bold} h3{color:#b45309;font-size:12px}</style></head><body>
    <h2>Cargas e recargas cobradas pela Tip</h2><div>Período: ${formatDateOnlyBR(dados.inicio)} a ${formatDateOnlyBR(dados.fim)}</div>
    <div class="cards">${cards}</div>${alertas}
    <table><thead><tr>${COLUNAS.slice(0, 10).map(c => `<th>${c}</th>`).join('')}</tr></thead><tbody>${corpo}</tbody>
    <tfoot><tr><td colspan="9">Total (${itens.length} lançamentos)</td><td>${brl(somar(itens))}</td></tr></tfoot></table></body></html>`);
  w.document.close();
  w.focus();
  w.print();
  return true;
}
